import axios from 'utils/axios';
import type { AuthMode, AuthResponse, LoginCredentials } from '../types';

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await axios.post('/api/v1/auth/login', credentials);
    return response.data;
  },
  getConfig: async (): Promise<{ mode: AuthMode }> => {
    const response = await axios.get('/api/v1/auth/config');
    return response.data;
  },
  requestLoginCode: async (email: string): Promise<{ message: string }> => {
    const response = await axios.post('/api/v1/auth/login-code/request', { email });
    return response.data;
  },
  verifyLoginCode: async (email: string, code: string): Promise<AuthResponse> => {
    const response = await axios.post('/api/v1/auth/login-code/verify', { email, code });
    return response.data;
  },
  forgotPassword: async (email: string): Promise<void> => {
    await axios.post('/api/v1/auth/forgot-password', { email });
  },
  resetPassword: async (payload: { email: string; token: string; password: string; passwordConfirmation: string }): Promise<void> => {
    await axios.post('/api/v1/auth/reset-password', {
      email: payload.email,
      token: payload.token,
      password: payload.password,
      password_confirmation: payload.passwordConfirmation
    });
  },
  /**
   * Activación de cuenta en modo sso_passwordless: el enlace del correo de invitación
   * solo confirma la cuenta (no define contraseña) para poder entrar con Microsoft u OTP.
   */
  activateAccount: async (payload: { email: string; token: string }): Promise<{ message: string }> => {
    const response = await axios.post('/api/v1/auth/activate-account', payload);
    return response.data;
  },
  logout: async (): Promise<void> => {
    await axios.post('/api/v1/auth/logout');
  },
  me: async (): Promise<AuthResponse['user']> => {
    const response = await axios.get('/api/v1/auth/me');
    return response.data;
  },
  updateProfilePhoto: async (foto: File): Promise<{ success: boolean; message: string; data: { foto: string } }> => {
    const formData = new FormData();
    formData.append('foto', foto);
    const response = await axios.post('/api/v1/auth/profile/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};
